import { useMemo } from "react";

export interface PickerVisibleInput {
  name: string;
  label: string;
  dataType: string;
  isList: boolean;
  isVariable: boolean;
  connectorType?: string;
  choices?: Array<{ data_type: string; is_list?: boolean }>;
}

/**
 * Compute the visible inputs for picker target expansion.
 */
export function useNodeInputs(
  regEntry: { inputs?: unknown[]; outputs?: unknown[] } | undefined,
  isSourceOnly: boolean
): PickerVisibleInput[] {
  return useMemo(() => {
    if (!regEntry || isSourceOnly) return [];
    const connectors = (regEntry.inputs ?? []) as Array<{
      name: string;
      label?: string;
      type?: string;
      definition?: { data_type?: string; is_list?: boolean };
      visible?: boolean;
      choices?: Array<{ data_type: string; is_list?: boolean }>;
    }>;
    return connectors
      .filter((i) => i.visible !== false && i.name)
      .map((i) => {
        const isVariable =
          i.type === "variable_connector" ||
          i.type === "variable_type_size_connector";
        return {
          name: i.name,
          label: i.label || i.name,
          dataType: i.definition?.data_type ?? "object",
          isList: i.definition?.is_list ?? false,
          isVariable,
          connectorType: i.type,
          choices: i.choices,
        };
      });
  }, [regEntry, isSourceOnly]);
}
